// A serial Nidus mints for a trap the manufacturer does not serialize. The
// serial is the district's durable identity for a physical trap (§33), and it
// is printed on the device's sticker, so it has to be readable off a worn label
// and never mistaken for a manufacturer's own serial or for a sample label.

/** The characters a generated serial may use: digits 3-9 and capital letters,
 *  leaving out the pairs a person reads alike — no 0 or O, no 1 or I, no 2 or Z.
 *  The sample labels draw from this same alphabet. */
export const TRAP_SERIAL_ALPHABET = "3456789ABCDEFGHJKMNPQRSTUVWXY";

/** How many characters follow the district slug and the TD designator. */
export const TRAP_SERIAL_LENGTH = 6;

/** A generated serial: the district's slug, the TD designator naming it a trap
 *  device, then TRAP_SERIAL_LENGTH characters from the unambiguous alphabet.
 *  The slug keeps two districts' serials apart; TD tells a sticker found on its
 *  own that it belongs to a trap, not to a sample (SL). */
export function generateTrapSerial(slug: string): string {
	const code: string[] = [];
	const bytes = new Uint8Array(TRAP_SERIAL_LENGTH);
	while (code.length < TRAP_SERIAL_LENGTH) {
		crypto.getRandomValues(bytes);
		for (const byte of bytes) {
			// The alphabet does not divide 256 evenly; the tail is discarded so
			// no character is more likely than another.
			if (byte >= 240) continue;
			code.push(TRAP_SERIAL_ALPHABET[byte % TRAP_SERIAL_ALPHABET.length]);
			if (code.length === TRAP_SERIAL_LENGTH) break;
		}
	}
	return `${slug}-TD-${code.join("")}`;
}
